import EmptyState from "./EmptyState";
import ErrorState from "./ErrorState";
import { PageSpinner } from "./Spinner";

/**
 * Renders the right thing for a useApiQuery result, so pages stop
 * re-implementing `if (!data) return <big spinner div>`.
 */
const QueryBoundary = ({
  loading,
  error,
  data,
  refetch,
  isEmpty,
  emptyMessage,
  children,
}) => {
  if (loading) return <PageSpinner />;
  if (error) return <ErrorState onRetry={refetch} />;
  if (!data) return null;
  if (isEmpty?.(data)) return <EmptyState message={emptyMessage} />;
  return children(data);
};

export default QueryBoundary;
